module.exports = __webpack_public_path__ + "img/i_solved_logo.37d1c6d2.png";